export default {
  data() {
    return {
      SITE: process.env.VUE_APP_PROJECT_NAME,
    };
  },
  computed: {
    is_KK() {
      return this.SITE === "KK";
    },
    IS_NUTS() {
      return this.SITE === "NUTS";
    },
  },
};
